import React from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { Toolbar, BottomPanel } from 'src/components';
import { CompanyInformation } from 'src/api/lk/types';
import { RoutingContainer, RoutingToolbarContainer, RoutingPageContainer } from './styles';
import { Landing, Leaderboard, Testing, UnknownRoute } from '..';
import DefaultLogo from '../../assets/logo.svg';

type RoutingContextType = {
  setCompany?: (companyLogoUrl?: string, companySiteUrl?: string) => void;
};

export const RoutingContext = React.createContext<RoutingContextType>({});

/*
  Функция для определения высоты экрана
  с учетом нижней панели
*/
function setHeight() {
  const vh = window.innerHeight * 0.01;
  const container = document.getElementById('routing-container');
  if (container) container.style.setProperty('--vh', `${vh}px`);
}

export const Routing: React.FC = () => {
  const [companyLogoUrl, setCompanyLogoUrl] = React.useState<string>(DefaultLogo);
  const [companySiteUrl, setCompanySiteUrl] = React.useState<string>('');

  const setCompany = React.useCallback(
    (companyLogoUrl?: string, companySiteUrl?: string) => {
      if (companyLogoUrl) {
        setCompanyLogoUrl(companyLogoUrl);
      }
      if (companySiteUrl) {
        setCompanySiteUrl(companySiteUrl);
      }
    },
    []
  );

    React.useEffect(() => {
    const loadCompanyConfig = async () => {
    try {
      const response = await fetch('/company-config.json');
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const config: CompanyInformation = await response.json();

      if (config.logo) {
        setCompanyLogoUrl(config.logo);
      }

      if (config.site) {
        setCompanySiteUrl(config.site);
      }
    } catch (error) {
      console.error('Failed to load company config:', error);
    }
  };

    loadCompanyConfig();
  }, []);

  React.useEffect(() => {
    window.addEventListener('resize', setHeight);
    setHeight();
    return () => window.removeEventListener('resize', setHeight);
  }, []);

  React.useEffect(() => {
    const forbidden = (e: KeyboardEvent) => {
      if (e.key === 'F12') e.preventDefault();
    };
    window.oncontextmenu = () => false;
    window.addEventListener('keydown', forbidden);
    return () => window.removeEventListener('keydown', forbidden);
  }, []);

  return (
    <RoutingContext.Provider
      value={{ setCompany }}
    >
      <BrowserRouter>
        <RoutingContainer id="routing-container">
          <RoutingToolbarContainer>
            <Toolbar companyLogoUrl={companyLogoUrl} companySiteUrl={companySiteUrl} />
          </RoutingToolbarContainer>
          <RoutingPageContainer>
            <Routes>
              {/* Главная страница */}
              <Route path="/" element={<Landing />} />

              {/* Промо-группы */}
              <Route path="/group/:code" element={<Landing />} />
              <Route path="/group/:code/leaderboard" element={<Leaderboard />} />

              {/* Старый промо путь */}
              <Route path="/promo/:code" element={<Landing />} />
              <Route path="/promo/:code/leaderboard" element={<Leaderboard />} />

              {/* Старые тесты */}
              <Route path="/:id" element={<Testing />} />
              <Route path="/:id/*" element={<UnknownRoute />} />
            </Routes>
          </RoutingPageContainer>
          <BottomPanel />
        </RoutingContainer>
      </BrowserRouter>
    </RoutingContext.Provider>
  );
};
